import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'restrict',
    templateUrl: './restrict.component.html',
    styleUrls: ['./restrict.component.scss'],
    standalone: false
})
export class RestrictComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
